<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Bulk Upload'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Replace all checklists, reservations, or inventory by exporting or importing.'" />
      </tidy-row>
      <tidy-alert>
        <tidy-row>
          <form [formGroup]="form">
            <tidy-radio-button
              [label]="'What would you like to import / export?'"
              [items]="typeItems"
              [form]="form.controls.type"
              formControlName="type" />
          </form>
        </tidy-row>
      </tidy-alert>
      <tidy-card>
        <tidy-row>
          <tidy-text
            [header]="'Export'" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="'Would you like to export this?'" />
        </tidy-row>
        <tidy-button
          [text]="('Export ' | translate) + getSelectedTypeName()"
          [action]="boundExportItem"
          class="secondary" />
      </tidy-card>
      <tidy-card>
        <tidy-row>
          <tidy-text
            [header]="'Import'" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="'Replace all reservations/inventory/checklists by importing. When you upload a new file it will replace everything, so make sure the import is complete.'" />
        </tidy-row>
        @if (form.value.type === 'guest_reservations') {
          <form [formGroup]="reservationImportForm">
            <tidy-row class="field-top-padding field-bottom-padding" >
              <tidy-select
                [icon]="'assets/svg/location-outline.svg'"
                [label]="'CSV Format'"
                [items]="guestReservationCsvSourceList"
                [form]="reservationImportForm.get('sourceTypeId')"
                formControlName="sourceTypeId" />
            </tidy-row>
            <tidy-row>
              <tidy-checkbox
                [items]="[{value: true, viewValue: 'Replace all reservations'}]"
                [initValue]="replaceAll"
                (checkedChange)="replaceAllChanged($event)" />
              <tidy-text
                body="Replace reservations from all sourcess."
              />
            </tidy-row>
          </form>
        }
        @if (form.value.type === 'room_objects') {
          <tidy-row>
            <tidy-checkbox
              [items]="[{value: true, viewValue: 'Update all properties'}]"
              [initValue]="replaceAll"
              (checkedChange)="replaceAllChanged($event)" />
            @if (!replaceAll) {
              <tidy-text
                body="Only properties included on the sheet will be updated if not enabled."
              />
            }
            @if (replaceAll) {
              <tidy-text
                body="All properties, even the ones not included on the sheet will be updated."
              />
            }
          </tidy-row>
        }
        <tidy-button
          [text]="('Import ' | translate) + getSelectedTypeName()"
          [action]="boundImportItem"
          class="secondary" />
        @if (showNotCSVError) {
          <tidy-row class="extra-top-padding">
            <tidy-error-message
              [text]="'Please import a CSV file.'" />
          </tidy-row>
        }
      </tidy-card>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
